const ACRONYMS = new Set(['id', 'url', 'psa', 'sla', 'sms', 'crm', 'api', 'ip', 'mx', 'dns', 'ui']);

const KEY_LABELS: Record<string, string> = {
  ticket_id: 'Ticket',
  ticketid: 'Ticket',
  board_id: 'Board',
  status_id: 'Status',
  priority_id: 'Priority',
  company_id: 'Company',
  contact_id: 'Contact',
  member_id: 'Assigned to',
  resource_id: 'Assigned to',
  owner_id: 'Owner',
  type_id: 'Type',
  subtype_id: 'Subtype',
  item_id: 'Item',
  source_id: 'Source',
  time_start: 'Start time',
  time_end: 'End time',
  hours_worked: 'Hours worked',
  internal_analysis_flag: 'Internal note',
  detail_description_flag: 'Visible to customer',
  resolution_flag: 'Resolution',
  psa: 'PSA',
};

const capitalise = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1);

export const humanizeConfirmationKey = (key: string): string => {
  const mapped = KEY_LABELS[key.toLowerCase()];
  if (mapped) return mapped;
  const words = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length > 1 && words[words.length - 1] === 'id') words.pop();
  const label = words.map(word => (ACRONYMS.has(word) ? word.toUpperCase() : word)).join(' ');
  return capitalise(label);
};

export const CONFIRMATION_FALLBACK_TITLE = 'Confirm this change';

export const confirmationTitle = (title: string | undefined): string => {
  const trimmed = title?.trim();
  if (!trimmed) return CONFIRMATION_FALLBACK_TITLE;
  return trimmed;
};

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const scalarText = (value: unknown): string => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
};

export const formatConfirmationValue = (value: unknown): string[] => {
  if (value === undefined || value === null) return [];
  if (Array.isArray(value)) {
    if (value.every(item => !isPlainObject(item) && !Array.isArray(item))) {
      return [value.filter(item => item !== undefined && item !== null).map(scalarText).join(', ')];
    }
    return value.flatMap(item => formatConfirmationValue(item));
  }
  if (isPlainObject(value)) {
    return Object.entries(value).flatMap(([key, inner]) => {
      if (inner === undefined || inner === null) return [];
      const label = humanizeConfirmationKey(key);
      if (isPlainObject(inner) || Array.isArray(inner)) {
        const lines = formatConfirmationValue(inner);
        if (lines.length === 1 && !isPlainObject(inner)) return [`${label}: ${lines[0]}`];
        return [`${label}:`, ...lines.map(line => `  ${line}`)];
      }
      return [`${label}: ${scalarText(inner)}`];
    });
  }
  return [scalarText(value)];
};
